import axios from 'axios'

if (process.env.NODE_ENV == "production") {
    const sucess = res => res 
    const error = err => {
        // Caso o erro não tenha response ele seta um valor padrão
        if (typeof err.response == 'undefined'){
            var errorStatus = 0
        }
        else{
            // seta o valor do erro
            var errorStatus = err.response.status
        }
        // Lista de erros que devem ser redirecionados
        const arrayError = [403];
        //verifica se contem o erro na lista
        if (arrayError.indexOf(errorStatus) >= 0 ){
            localStorage.clear();
            try {
                // Tenta pegar a url da store
                var urlLogout = this.$store.state.application.callback_url;
                window.location.replace("https://" + urlLogout);
            } catch(e) {
                // Caso não consiga buscar a url
                window.location = '/login'
            }
        }
        else {
            // Os erros que não estão na lista não são redirecionados
            return Promise.reject(err)
        }
    }

    axios.interceptors.response.use(sucess,error)
}


// WEBPACK FOOTER //
// ./src/axios.js